module.exports = __webpack_public_path__ + "static/img/wave-period.57956bbb.png";